export default {
    state: {},
    getters: {},
    mutations: {},
    actions: {
        getAllCategories(_, exceptID) {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/category/all" + (exceptID ? '?except_id=' + exceptID : ''))
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        getCategoriesWithoutChild() {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/category/all-without-child")
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        getPaginatedCategories(_, page) {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/category/index?page=" + page)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        deleteCategory(_, identifier) {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/category/delete/" + identifier)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        createCategory(_, data) {
            let formData = new FormData();
            Object.keys(data).forEach(key => {
                if (data[key] && data[key].constructor === Array) {
                    data[key].forEach((value, key2) => {
                        formData.append(key + '[' + key2 + ']' + '[x]', value.x)
                        formData.append(key + '[' + key2 + ']' + '[y]', value.y)
                        formData.append(key + '[' + key2 + ']' + '[title]', value.title)
                        formData.append(key + '[' + key2 + ']' + '[description]', value.description)
                        formData.append(key + '[' + key2 + ']' + '[button_text]', value.button_text ?? '')
                        formData.append(key + '[' + key2 + ']' + '[button_link]', value.button_link ?? '')
                    })
                } else if (data[key]) {
                    formData.append(key, data[key])
                }
            });
            return new Promise((resolve, reject) => {
                window.axios.post("/admin/category/store", formData)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        updateCategory(_, payload) {
            let formData = new FormData();
            Object.keys(payload.data).forEach(key => {
                if (payload.data[key] && payload.data[key].constructor === Array) {
                    payload.data[key].forEach((value, key2) => {
                        formData.append(key + '[' + key2 + ']' + '[x]', value.x)
                        formData.append(key + '[' + key2 + ']' + '[y]', value.y)
                        formData.append(key + '[' + key2 + ']' + '[title]', value.title)
                        formData.append(key + '[' + key2 + ']' + '[description]', value.description)
                        formData.append(key + '[' + key2 + ']' + '[button_text]', value.button_text ?? '')
                        formData.append(key + '[' + key2 + ']' + '[button_link]', value.button_link ?? '')
                    })
                } else if (payload.data[key]) {
                    formData.append(key, payload.data[key])
                }
            });
            return new Promise((resolve, reject) => {
                window.axios.post("/admin/category/update/" + payload.identifier, formData)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        singleCategory(_, identifier) {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/category/show/" + identifier)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
    },
}

